module.exports = __webpack_public_path__ + "static/media/IMG_1255.0ddf90a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/IMG_1255.jpg
// module id = 460
// module chunks = 0